import { render } from "./BallDrop.vue?vue&type=template&id=73b805b8&scoped=true"
import script from "./BallDrop.vue?vue&type=script&lang=ts"
export * from "./BallDrop.vue?vue&type=script&lang=ts"

import "./BallDrop.vue?vue&type=style&index=0&id=73b805b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73b805b8"

export default script